import { useEffect, useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { Container, MainContainer, Wrapper, Title, Image, ResultsContainer, ResultsWrapper, VetDetail, Text, Button } from './styles';
import vet from '../../assets/images/vet.png'
import { useNavigate } from 'react-router-dom';
import useAxios from '../../context/hooks/useAxios';

function Vets() {
  const [addresses, setAddresses] = useState([]);
  const [vets, setVets] = useState([]);
  const [allVeterinarians, setAllVeterinarians] = useState([]);
  const { fetchVeterinarians, response } = useAxios();

  useEffect(() => {
    fetchVeterinarians()
  }, [fetchVeterinarians]);

  useEffect(() => {
    if (response) {
      setAllVeterinarians(response);
      setAddresses(
        [...new Map(response.map(vet => [vet.endereco.cidade, vet.endereco])).values()]
      )
    }
  }, [response]);

  const handleOnSelect = (address) => {
    setVets(allVeterinarians.filter((vet) => vet.endereco.cidade === address.cidade));
  }

  const handleOnClear = () => {
    setVets([]);
  }

  const vetSpecialties = (specialties) => {
    return specialties.map(specialty => specialty.name).join(', ');
  }

  const vetDetailText = (vet) => {
    let detailText = [];
    detailText.push(vet.nome);
    if (vet.especialidades.length) detailText.push(vetSpecialties(vet.especialidades));
    detailText.push(vet.endereco.bairro);
    return detailText.join(' - ');
  }

  const navigate = useNavigate();

  return (
    <Container>
      <MainContainer>
        <Wrapper>
          <Title color='#000'>Encontre médicos veterinários e especialistas próximo a você.</Title>
          <ReactSearchAutocomplete
            items={addresses}
            fuseOptions={
              {
                keys: ["cidade"],
                threshold: 0.5,
                minMatchCharLength: 2
              }
            }
            resultStringKeyName="cidade"
            placeholder='Procure aqui a cidade'
            autoFocus
            onSelect={handleOnSelect}
            onClear={handleOnClear}
            showNoResultsText="Sem resultados"
            styling={{
              borderRadius: "8px",
              backgroundColor: "#E6E6E6",
              color: "#555",
              fontFamily: "Poppins",
              hoverBackgroundColor: "#E0E0E0",
              placeholderColor: "black"
            }}
          />
        </Wrapper>
        {vets.length === 0 && <Image src={vet} />}
      </MainContainer>
      {
        vets.length !== 0 &&
        <ResultsContainer>
          <Title color='#168C5A'>Veterinários em cidade: </Title>
          <ResultsWrapper>
            {
              vets.map(vet => {
                return (
                  <VetDetail key={vet.id}>
                    <Text>{vetDetailText(vet)}</Text>
                    <Button onClick={() => navigate(`/medicos-veterinarios/${vet.id}`)}>VER DETALHES</Button>
                  </VetDetail>
                )
              })
            }

          </ResultsWrapper>
        </ResultsContainer>
      }
    </Container>
  )
}

export default Vets;